export default __webpack_public_path__ + "static/media/tandoori.1b4d6857.jpg";